/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["nav[_ngcontent-%COMP%]{width:100%;max-width:990px;margin:auto;padding:0 16px;box-sizing:border-box}section[_ngcontent-%COMP%]{color:#f0f0f0;background:#006fbf;padding-top:.3em;padding-bottom:.3em}nav[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]{color:#f0f0f0;font-size:.9em;font-weight:700;padding:16px 22px;text-transform:uppercase;text-decoration:none}nav[_ngcontent-%COMP%]   a.active[_ngcontent-%COMP%], nav[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{color:#0a60a9;background:#f0f0f0}"];
export { styles as styles };
